import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M17.25 5C17.25 4.30964 16.6904 3.75 16 3.75H7C6.30964 3.75 5.75 4.30964 5.75 5V19C5.75 19.6904 6.30964 20.25 7 20.25H16C16.6904 20.25 17.25 19.6904 17.25 19V17.0059C17.25 16.5917 17.5858 16.2559 18 16.2559C18.4142 16.2559 18.75 16.5917 18.75 17.0059V19C18.75 20.5188 17.5188 21.75 16 21.75H7C5.48122 21.75 4.25 20.5188 4.25 19V5C4.25 3.48122 5.48122 2.25 7 2.25H16C17.5188 2.25 18.75 3.48122 18.75 5V7.04821C18.75 7.46243 18.4142 7.79821 18 7.79821C17.5858 7.79821 17.25 7.46243 17.25 7.04821V5ZM8.45 11.6782C8.45 11.264 8.78578 10.9282 9.2 10.9282H16.675L14.417 8.73864C14.1197 8.45029 14.1124 7.97547 14.4007 7.67811C14.6891 7.38074 15.1639 7.37344 15.4612 7.66179L19.0362 11.1284C19.1811 11.2629 19.2727 11.4539 19.276 11.6664C19.2761 11.6704 19.2761 11.6744 19.2761 11.6785C19.2761 11.692 19.2757 11.7055 19.275 11.719C19.2686 11.8377 19.2347 11.9491 19.1794 12.0469C19.1444 12.109 19.1003 12.1663 19.0482 12.2169L15.4612 15.6952C15.1639 15.9835 14.6891 15.9762 14.4007 15.6788C14.1124 15.3815 14.1197 14.9067 14.417 14.6183L16.6756 12.4282H9.2C8.78578 12.4282 8.45 12.0924 8.45 11.6782Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const LogOutOutlined = React.forwardRef(IconComponent);
LogOutOutlined.displayName = 'LogOutOutlined';

export { LogOutOutlined };
